import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxFileDropModule } from "ngx-file-drop";
import { LightboxModule } from "ngx-lightbox";
import { UiSwitchModule } from "ngx-ui-switch";
import { IconsModule } from "src/shared/Modules/icons.module";
import { TableModule } from "src/shared/Modules/table.module";

import { FormComponentsModule } from "../../shared/Modules/formComponents.module";
import { SharedModule } from "../../shared/Modules/shared.module";
import { FileHandlerService } from "../../shared/Services/fileHandler.service";

import { FiduciariaRoutingModule } from "./fiduciaria-routing.module";
import { TrustRepository } from "./Shared/Repositories/trust.repository";
import { FiduciaryRepository } from "./Shared/Repositories/fiduciary.repository";
import { TrustService } from "./Shared/Services/trust.service";
import { RequestDetailsDocumentsService } from "./Shared/Services/request-details-documents.service";
import { FiduciaryUtilsService } from "./Shared/Services/fiduciary-utils.service";

import { CanalesRepository } from "../Canales/Shared/Repositories/canales.repository";
import { CanalesService } from "../Canales/Shared/Services/canales.service";
import { UserCreationService } from "../Canales/Shared/user-creation.service";
import { NuevoFiduciariaService } from "../Canales/UserFiduciary/Shared/Services/nuevo-fiduciaria.service";
import { CanalesModule } from "../Canales/canales.module";
import { RequestCreationModule } from "./RequestCreation/request-creation.module";
import {FiduciarySearchModule} from "./RequestSearch/fiduciary-request-search.module";

@NgModule({
  imports: [
    FiduciariaRoutingModule,
    CommonModule,
    FormComponentsModule,
    IconsModule,
    TableModule,
    NgxFileDropModule,
    LightboxModule,
    SharedModule,
    UiSwitchModule,
    CanalesModule,
    FiduciarySearchModule,
    RequestCreationModule,
  ],
  providers: [
    FileHandlerService, 
    TrustRepository, 
    TrustService,
    CanalesService,
    CanalesRepository,
    UserCreationService,
    NuevoFiduciariaService,
    FiduciaryRepository,
    RequestDetailsDocumentsService,
    FiduciaryUtilsService
  ],
})
export class FiduciariaModule {}
